import { Col, Container, Row } from 'react-bootstrap';
import { motion } from "motion/react";
import brandData from '../../data/brandData.json';

const Pillars = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  }

  const pillarVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  const progressVariants = {
    hidden: { width: 0 },
    visible: (progress) => ({
      width: `${progress}%`,
      transition: { duration: 1, ease: "easeOut", delay: 0.3 }
    })
  }

  return (
    <section className='section-lg overflow-hidden' id='brand-pillars'>
      <Container>
        <Row>
          <Col xs={12} className='mb-5'>
            <motion.h6 className="underline-after position-relative text-center z-0"
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: 'linear', delay: 0.1 }}
            >
              <span className="position-relative z-1 bg-white text-primary px-3">Pillars</span>
            </motion.h6>
            <motion.h1 className="d-block text-gradiant text-center fw-semibold"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: 'linear', delay: 0.1 }}
            >
              What makes a brand memorable
            </motion.h1>
          </Col>
        </Row>
        <div className="bg-light rounded-4 p-3 p-md-4">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <Row className="g-4 align-items-stretch text-center">
              {brandData.pillars.map((pillar, index) => (
                <Col md={4} key={pillar.id}>
                  <motion.div className={`h-100 d-flex flex-column justify-content-between px-md-3 ${index < brandData.pillars.length - 1 ? 'border-end d-none d-md-flex' : ''}`}
                    variants={pillarVariants}
                    whileHover={{ y: -8, transition: { duration: 0.3 } }}
                  >
                    <div>
                      <motion.div className={`d-inline-flex align-items-center justify-content-center rounded-circle bg-${pillar.iconBg}-subtle text-${pillar.iconBg} mb-2`}
                        style={{ width: '56px', height: '56px' }}
                        whileHover={{ rotate: 360, scale: 1.1 }}
                        transition={{ duration: 0.5 }}
                      >
                        <i className={`${pillar.icon} fs-4`}></i>
                      </motion.div>
                      <h5 className="mb-1">{pillar.title}</h5>
                      <p className="text-secondary small mb-0">{pillar.description}</p>
                    </div>
                    <div className="progress mt-3" style={{ height: '4px' }}>
                      <motion.div className={`progress-bar bg-${pillar.iconBg}`}
                        variants={progressVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        custom={pillar.progress}
                      ></motion.div>
                    </div>
                  </motion.div>
                  <div className="d-md-none">
                    <div className={`d-inline-flex align-items-center justify-content-center rounded-circle bg-${pillar.iconBg}-subtle text-${pillar.iconBg} mb-2`} style={{ width: '56px', height: '56px' }}>
                      <i className={`${pillar.icon} fs-4`}></i>
                    </div>
                    <h5 className="mb-1">{pillar.title}</h5>
                    <p className="text-secondary small mb-0">{pillar.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </motion.div>
        </div>
      </Container>
    </section>
  )
}

export default Pillars;
